/**
 * @generated SignedSource<<4637cb040ec4a196ef80158a6f163e37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchEntityType = "EVENT" | "GUILD" | "PRESENTATION" | "USER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SearchResultRowNew_searchResult$data = {
  readonly entity: {
    readonly memberCount?: number;
    readonly name?: string;
    readonly owner?: {
      readonly name?: string;
    } | null | undefined;
    readonly presenterFirstName?: string | null | undefined;
    readonly presenterLastName?: string | null | undefined;
    readonly slug?: string;
    readonly slugId?: string;
    readonly startAt?: string;
    readonly title?: string;
    readonly " $fragmentSpreads": FragmentRefs<"EventCoverPhotoNew_event" | "GuildPrimaryPhotoNew_guild" | "PresentationPresenterPhotoNew_presentation">;
  };
  readonly entityType: SearchEntityType;
  readonly " $fragmentType": "SearchResultRowNew_searchResult";
};
export type SearchResultRowNew_searchResult$key = {
  readonly " $data"?: SearchResultRowNew_searchResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchResultRowNew_searchResult">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "dpr",
    "value": 3
  },
  {
    "kind": "Literal",
    "name": "imageSize",
    "value": 48
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchResultRowNew_searchResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slugId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "memberCount",
              "storageKey": null
            },
            {
              "args": (v1/*: any*/),
              "kind": "FragmentSpread",
              "name": "GuildPrimaryPhotoNew_guild"
            }
          ],
          "type": "Guild",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "type": "Guild",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": (v1/*: any*/),
              "kind": "FragmentSpread",
              "name": "EventCoverPhotoNew_event"
            }
          ],
          "type": "Event",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "presenterFirstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "presenterLastName",
              "storageKey": null
            },
            {
              "args": (v1/*: any*/),
              "kind": "FragmentSpread",
              "name": "PresentationPresenterPhotoNew_presentation"
            }
          ],
          "type": "Presentation",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SearchResult",
  "abstractKey": null
};
})();

(node as any).hash = "01232ca2a0cef7db2a2e378f64fe2622";

export default node;
